<template>
	<div class="sortable-list">
		<SortableListItem
			v-for="(child, index) in $slots.default"
			:key="child.data.key"
			:first="index === 0"
			:last="index === $slots.default.length - 1"
			@remove="() => removeItem(child.data.key)"
			@reorder="({ dir }) => reorderItem(child.data.key, dir)"
		>
			<Vnode :node="child" />
		</SortableListItem>
	</div>
</template>

<script>
import SortableListItem from '@/components/SortableListItem'
import { swap } from '@/lib/helpers'

export default {
	name: 'SortableList',
	props: {
		value: Array,
		keyProp: {
			type: String,
			required: true,
		},
	},
	methods: {
		reorderItem(key, dir) {
			const a = this.value.findIndex(item => item[this.keyProp] === key)
			const b = a + dir

			// Swap items at positions a and b
			this.$emit('input', swap(this.value, a, b))
		},
		removeItem(key) {
			this.$emit(
				'input',
				this.value.filter(item => item[this.keyProp] !== key)
			)
		},
	},
	components: {
		SortableListItem,
		Vnode: {
			functional: true,
			render: (h, ctx) => ctx.props.node,
		},
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.sortable-list {
	@include truncate-margin;
	position: relative;
}
</style>
